var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"scroll":_vm.handleScroll}},[_c('reservation-effect',{attrs:{"type":_vm.effectType,"width":_vm.viewportSize.width,"height":_vm.viewportSize.height,"y":_vm.scrollV}}),_c('div',{staticClass:"content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }